import { technologies } from '../data/content';

const TechStrip = () => (
  <section aria-label="Technologies used" className="border-y border-white/[0.06] bg-white/[0.015]">
    <div className="container-page flex flex-col items-start gap-4 py-7 lg:flex-row lg:items-center lg:gap-10">
      <p className="shrink-0 font-mono text-xs uppercase tracking-[0.16em] text-subtle">Built with modern tools</p>
      <ul className="flex flex-wrap gap-x-7 gap-y-3">
        {technologies.map((tech) => (
          <li key={tech} className="text-sm font-medium text-muted">
            {tech}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TechStrip;
